// Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
    languageCode: 'nl' | 'fr' = 'nl';

    constructor(private activatedRoute: ActivatedRoute) {}

    ngOnInit() {
        this.languageCode = this.activatedRoute.snapshot.params['language_code'];
    }

    onSelectLanguageCode(lang: 'nl' | 'fr') {
        window.open(`/${lang}/privacy-policy`, '_self');
    }
}
